module.exports = __webpack_public_path__ + "static/media/prix_special.bce524c8.png";